var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3086 13.0391C13.1084 13.0391 14.7433 12.3204 15.9411 11.1568C16.3987 11.7952 16.668 12.5755 16.668 13.418V20.711H5.94922V13.418C5.94922 12.5755 6.21846 11.7952 6.67607 11.1568C7.87392 12.3204 9.50875 13.0391 11.3086 13.0391Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8412 3.59783L14.9108 4.01562H15.3344H15.9961C17.4273 4.01562 18.6048 5.12669 18.711 6.53125H17.9501C17.8464 5.54443 17.01 4.77344 15.9961 4.77344H6.62109C5.60715 4.77344 4.77075 5.54443 4.66707 6.53125H3.90624C4.01243 5.12669 5.18991 4.01562 6.62109 4.01562H7.28279H7.70635L7.77599 3.59783L7.99472 2.2855L7.99473 2.28547C8.16725 1.2499 9.05245 0.5 10.1024 0.5H12.5148C13.5647 0.5 14.4499 1.24989 14.6225 2.28552L14.6225 2.28557L14.8412 3.59783Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3086 10.2812C9.56022 10.2812 8.07614 9.12183 7.58611 7.53125H15.031C14.541 9.12183 13.0569 10.2812 11.3086 10.2812Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4258 13.418C19.4258 11.9644 18.9568 10.6185 18.1634 9.52344H20.4645C21.6423 9.52344 22.6012 10.4824 22.6012 11.6602C22.6012 12.8379 21.6423 13.7969 20.4645 13.7969H19.4258V13.418Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5859 7.24998C22.3438 7.13312 22.0905 7.0356 21.8281 6.95943V5.77344H22.5859V7.24998Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5859 23.1445V23.6445H23.0859H23.9648C25.1426 23.6445 26.1016 24.6035 26.1016 25.7813V29.5H25.3438V25.7813C25.3438 25.0205 24.7256 24.4024 23.9648 24.4024H23.0859H22.5859V24.9024V29.5H21.8281V24.9024V24.4024H21.3281H20.4492C19.6884 24.4024 19.0703 25.0205 19.0703 25.7813V29.5H18.3125V25.7813C18.3125 24.6035 19.2715 23.6445 20.4492 23.6445H21.3281H21.8281V23.1445V16.3609C22.0905 16.2848 22.3438 16.1872 22.5859 16.0704V23.1445Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92604 29.5L8.12187 23.4688H14.4953L13.6911 29.5H8.92604Z",
    fill: "#f69516",
    stroke: "#6D4B40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.adbb552c5b819e5a4e37d854847b1d5e.svg";
export { ForwardRef as ReactComponent };